// @flow

import { isPathNode } from 'app/beta-editor/utils/PathUtils';
import {
  createEditorUrl,
  isSetupBehaviorComplete,
} from 'app/beta-editor/utils/FlowUtils';

import type { RequiredBehaviors } from 'app/beta-editor/pages/types';

const label = 'Choose App & Event';

const setupBehavior: RequiredBehaviors = {
  label: () => label,
  menuLabel: () => label,
  crumbLabel: () => 'Setup',
  data: () => {},
  status: ({ node }) => (isSetupBehaviorComplete(node) ? 'success' : ''),
  visible: ({ node }) => !isPathNode(node),
  isClickable: () => true,
  isLocked: () => false,
  href: ({ flow, node }) =>
    createEditorUrl({
      flowId: flow.id,
      nodeId: node.id,
      pageKey: 'setup',
    }),
};

export default setupBehavior;
